
import { Autocomplete, TextField } from '@mui/material';
import { t } from 'i18next';
import { debounce, isEmpty, uniqueId } from 'lodash';
import React, { useEffect, useMemo, useRef, useState } from 'react'
import useOnclickOutside from 'react-cool-onclickoutside';
import usePlacesAutocomplete, {
    getGeocode,
    getLatLng,
} from "use-places-autocomplete";

type PlaceAutoCompleteProps = {
    onValueChange: (value: string | null) => void,
    defaultValue?: string | null
}

function PlaceAutoComplete({ onValueChange, defaultValue }: PlaceAutoCompleteProps) {

    const {
        ready,
        value,
        suggestions: { status, data, loading },
        setValue,
        clearSuggestions,
    } = usePlacesAutocomplete({

        requestOptions: {
            types: []
            /* Define search scope here */
        },
        debounce: 200,
    });


    useEffect(() => {
        if (defaultValue) {

            setValue(defaultValue)
        }
    }, [defaultValue, setValue])




    const handleInput = (e: any) => {
        setValue(e.target.value); // Prevents unnecessary API calls
        onValueChange('')
    };



    const formattedData = useMemo(() => {
        return data.length > 0 ? data.map(e => e.description) : []
    }, [data])

    

    return (
        <>
            <Autocomplete
                freeSolo
                renderInput={(params) => <TextField onChange={handleInput} value={value} {...params} label={t('info:address')} />}
                value={value}
                options={formattedData}
                loading={loading}
                getOptionLabel={e => e}
                getOptionKey={e => e}
                onChange={(e, value, reason) => {
                    clearSuggestions()
                    onValueChange(value)
                }}
            ></Autocomplete>
        </>
    )
}

export default PlaceAutoComplete